import { Button, Form, Input, Select } from 'antd';
import { useTranslation } from 'translations/hooks';

import { MainCard } from 'ui/components/main-card';

import type { FormInstance } from 'antd/lib';

import { useMemo } from 'react';
import type { DefectTypeDto } from 'generated/apiSchemas';

import { PictureUploadInput } from 'business/receipt/components/picture-upload-input';
import type { RepairFormValues } from 'business/receipt/pages/repair/types';

interface RepairFormProps {
  form: FormInstance<RepairFormValues>;
  save: (row: RepairFormValues) => void;
  defectRepairTypes: DefectTypeDto[];
  isFetching: boolean;
}

export const RepairForm = ({
  form,
  save,
  defectRepairTypes,
  isFetching,
}: RepairFormProps) => {
  const { t } = useTranslation();

  const defectRepairTypesOptions = useMemo(() => {
    return (
      defectRepairTypes.map((type) => ({
        label: type.label,
        value: type.id,
      })) || []
    );
  }, [defectRepairTypes]);

  return (
    <Form<RepairFormValues>
      form={form}
      onFinish={save}
      className="flex w-full flex-1 flex-col items-center justify-between px-4 py-4"
    >
      <MainCard>
        <Form.Item<RepairFormValues>
          name="type"
          label={t('receipt.repair.form.type')}
          rules={[{ required: true, message: t('common.fieldRequired') }]}
        >
          <Select
            placeholder={t('common.placeholder.select')}
            className="w-full"
            options={defectRepairTypesOptions}
          />
        </Form.Item>

        <Form.Item<RepairFormValues>
          name="description"
          label={t('chooseSegmentStatus.form.quarantine.description')}
        >
          <Input.TextArea
            placeholder={t('common.placeholder.inputText')}
            rows={4}
          />
        </Form.Item>

        <Form.Item<RepairFormValues>
          name="pictures"
          label={t('chooseSegmentStatus.form.quarantine.pictures')}
        >
          <PictureUploadInput maxCount={3} />
        </Form.Item>
      </MainCard>

      <Button
        type="primary"
        className="mt-4 w-full"
        htmlType="submit"
        loading={isFetching}
      >
        {t('common.validate')}
      </Button>
    </Form>
  );
};
